import VueCookies from 'vue-cookies'

export function contanisCookie (key) {
  return VueCookies.isKey(key)
}

export function removeCookie (key) {
  return VueCookies.remove(key)
}

export function getCookie (key) {
  return VueCookies.get(key)
}

/**
 *
 * @param {*} key
 * @param {*} value
 * @param {*} timeout  单位分钟
 * @returns
 */
export function setCookie (key, value, timeout) {
  return VueCookies.set(key, value, timeout * 60)
}



// WEBPACK FOOTER //
// ./src/api/libs/cookie.js